<gtw-confirmation-modal
  [config]="modalConfig"
  [visible]="true"
  (confirmed)="onConfirm()"
  (closed)="onConfirm()">
</gtw-confirmation-modal>
